import { ConfigurationProtocolResponse } from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol/configuration-protocol.dto'
import { ConfigurationAutomaticOntologyProtocolResponse } from '@/modules/configurationModule/detail/automation/protocols/services/configuration-automatic-ontology-protocol/configuration-automatic-ontology-protocol.dto'
import { ConfigurationOntologyForAutomaticProtocolResponse } from '@/modules/configurationModule/detail/automation/protocols/services/configuration-ontology-for-automatic-protocol/configuration-ontology-for-automatic-protocol.dto'
import { Nullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface ConfigurationAutomationProtocolsModalProtocolsFormState {
    ontologyForAutomaticProtocol: Nullable<ConfigurationOntologyForAutomaticProtocolResponse>
    protocols: ConfigurationProtocolResponse[]
    automaticOntologyProtocols: ConfigurationAutomaticOntologyProtocolResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationProtocolsModalProtocolsFormState =
    (): ConfigurationAutomationProtocolsModalProtocolsFormState => ({
        ontologyForAutomaticProtocol: null,
        protocols: [],
        automaticOntologyProtocols: [],
        laboratoryId: store.getters.labId
    })
